<template>
    <v-app>
        <v-content>
            <MainLayout/>
        </v-content>
    </v-app>
</template>

<script>
    import MainLayout from './components/MainLayout'

    export default {
        name: 'App',
        components: {
            MainLayout
        },
        data () {
            return {
            }
        },
        methods: {
            configEmptyText() {
                Chart.plugins.register({
                    afterDraw: function(chart) {
                        if (!chart.data || !chart.data.datasets || !chart.data.datasets[0] ||
                            !chart.data.datasets[0].data || chart.data.datasets[0].data.length === 0) {
                            // No data is present
                            const ctx = chart.chart.ctx;
                            const width = chart.chart.width;
                            const height = chart.chart.height;
                            chart.clear();

                            ctx.save();
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            ctx.font = "20px 'Helvetica'";
                            ctx.fillText('No data to display', width / 2, height / 2);
                            ctx.restore();
                        }
                    }
                });
            }
        },
        mounted() {
            this.configEmptyText();
        }
    }
</script>

<style>
    .v-icon {
        font-size: 1.5em!important;
    }
    .v-icon.fas {
        font-size: 1.3em!important;
    }
</style>
